import { View, Text, TouchableOpacity, Modal, ScrollView, StyleSheet } from 'react-native';
import { ExerciseHistory } from '@/lib/types';
import { ProgressChart } from '@/components/ProgressChart';

interface Props {
  history: ExerciseHistory | null;
  visible: boolean;
  onClose: () => void;
}

export function ExerciseProgressModal({ history, visible, onClose }: Props) {
  if (!history) return null;

  const loadData = history.entries
    .filter(e => e.load !== null)
    .map(e => ({
      value: e.load as number,
      label: new Date(e.date).toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' }),
    }));

  const hasLoad = loadData.length > 0;

  return (
    <Modal visible={visible} animationType="slide" onRequestClose={onClose}>
      <ScrollView style={styles.container} contentContainerStyle={{ padding: 20 }}>
        <TouchableOpacity onPress={onClose} style={styles.closeBtn}>
          <Text style={styles.closeBtnText}>← Fechar</Text>
        </TouchableOpacity>
        <Text style={styles.title}>{history.name}</Text>
        <Text style={styles.muscle}>{history.muscleGroup}</Text>

        {hasLoad ? (
          <ProgressChart data={loadData} title="Carga (kg)" minPoints={2} />
        ) : (
          <View style={styles.noLoad}>
            <Text style={styles.noLoadText}>Exercício sem registro de carga.</Text>
          </View>
        )}

        <View style={styles.statsRow}>
          <View style={styles.stat}>
            <Text style={styles.statLabel}>Primeira carga</Text>
            <Text style={styles.statValue}>{history.firstLoad !== null ? `${history.firstLoad.toFixed(1)}kg` : '—'}</Text>
          </View>
          <View style={styles.stat}>
            <Text style={styles.statLabel}>Última carga</Text>
            <Text style={styles.statValue}>{history.lastLoad !== null ? `${history.lastLoad.toFixed(1)}kg` : '—'}</Text>
          </View>
          <View style={styles.stat}>
            <Text style={styles.statLabel}>Evolução</Text>
            <Text style={[styles.statValue, { color: history.delta !== null && history.delta > 0 ? '#2E7D32' : history.delta !== null && history.delta < 0 ? '#C8102E' : '#888' }]}>
              {history.delta !== null ? (history.delta > 0 ? `+${history.delta.toFixed(1)}kg` : `${history.delta.toFixed(1)}kg`) : '—'}
            </Text>
          </View>
        </View>
      </ScrollView>
    </Modal>
  );
}

const styles = StyleSheet.create({
  container: { flex: 1, backgroundColor: '#F5F5F5' },
  closeBtn: { marginBottom: 16 },
  closeBtnText: { color: '#C8102E', fontSize: 15, fontWeight: '600' },
  title: { fontSize: 22, fontWeight: 'bold', color: '#1A1A1A', marginBottom: 4 },
  muscle: { fontSize: 13, color: '#888', marginBottom: 20 },
  noLoad: { backgroundColor: '#F5F5F5', borderRadius: 10, padding: 20, alignItems: 'center', marginBottom: 16 },
  noLoadText: { color: '#aaa', fontSize: 14 },
  statsRow: { flexDirection: 'row', backgroundColor: '#fff', borderRadius: 10, padding: 16, gap: 8 },
  stat: { flex: 1, alignItems: 'center' },
  statLabel: { fontSize: 11, color: '#888', marginBottom: 4 },
  statValue: { fontSize: 16, fontWeight: 'bold', color: '#1A1A1A' },
});
